<div class="wrapper p-2">
    <div class="container-flex d-flex justify-content-center">
        <div class="content-area card">
            <!--<div class="content-body">-->
                <object [safeSourceContent]="url" class="termos" title="E-Flow"></object>
            <!--</div>-->
        </div>
    </div>
</div>
